 $(document).ready(function(){
  $('.grid').masonry({
  // options
  itemSelector: '.grid-item1',
  columnWidth: 200
});   
 $('.review-slider').slick({
  centerMode: true,
  centerPadding: '0px',
  arrows:true,
  autoplay:true,
  dots:false,
  slidesToShow: 3,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        centerPadding: '170px',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerPadding: '50px',
        slidesToShow: 1
      }
    }
  ]
});
 });